var link_viewer_default = {
  "fontElementMap": "eNc8S",
  "link": "XSxHY",
  "linkInEditor": "JW8AG",
  "linkInViewer": "gMMfB",
  "toolbarUrlContainer": "LSRFZ",
  "toolbarUrl": "_69-0F",
  "toolbarUrlAnchor": "wn9Z1"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
